"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-use-before-define
const react_1 = __importStar(require("react"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const List_1 = __importDefault(require("@material-ui/core/List"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const react_hooks_1 = require("@apollo/react-hooks");
const apollo_boost_1 = require("apollo-boost");
const moment_1 = __importDefault(require("moment"));
const ActionButtons_1 = __importDefault(require("coact/pages/modules/pageAction/ActionButtons"));
const core_1 = require("@material-ui/core");
const InventoryAdjustmentListItemUIView_1 = require("./InventoryAdjustmentListItemUIView");
const InventoryAdjustmentInfoStatus_1 = require("../InventoryAdjustmentInfoStatus");
const GET_INVENTORY_ADJUSTMENT_INFO = apollo_boost_1.gql `
  query getInventoryAdjustmentInfo($id: String!) {
    getInventoryAdjustmentInfo(id: $id) {
      _id
      sn
      createdAt
      submittedAt
      status
      items
      {
        _id
        amount
        order
        product
        {
          _id
          key
          stockId
        }
        unitCost
      }
    }
  }
`;
const DELETE_INVENTORY_ADJUSTMENT_INFO = apollo_boost_1.gql `
  mutation deleteInventoryAdjustmentInfo($id: String!) {
    deleteInventoryAdjustmentInfo(id: $id) {
      _id
      status
    }
  }
`;
const UPDATE_INVENTORY_ADJUSTMENT_ITEMS = apollo_boost_1.gql `
  mutation updateInventoryAdjustmentInfoItems($id: String!, $items: [InventoryAdjustmentInfoItemInput!]!) {
    updateInventoryAdjustmentInfoItems(id: $id, items: $items) {
      _id
      status
      items {
        _id
        amount
        order
        productId
        unitCost
      }
    }
  }
`;
const APPLY_INVENTORY_ADJUSTMENT_INFO = apollo_boost_1.gql `
  mutation applyInventoryAdjustmentInfoItems($id: String!, $items: [InventoryAdjustmentInfoItemInput!]!) {
    applyInventoryAdjustmentInfo(id: $id, items: $items) {
      _id
      status
      submittedAt
      items
      {
        _id
        amount
        order
        productId
        unitCost
      }
    }
  }
`;
function InventoryAdjustmentInfoUIView(props) {
    const inventoryAdjustmentInfoId = props.match.params.id;
    const [deleteInfo] = react_hooks_1.useMutation(DELETE_INVENTORY_ADJUSTMENT_INFO, {
        variables: {
            id: inventoryAdjustmentInfoId,
        },
    });
    const [applyInfo] = react_hooks_1.useMutation(APPLY_INVENTORY_ADJUSTMENT_INFO);
    const [updateInfoItems] = react_hooks_1.useMutation(UPDATE_INVENTORY_ADJUSTMENT_ITEMS);
    const { data, loading, refetch } = react_hooks_1.useQuery(GET_INVENTORY_ADJUSTMENT_INFO, {
        variables: {
            id: inventoryAdjustmentInfoId,
        },
    });
    const [items, setItems] = react_1.useState([]);
    const [maxOrder, setMaxOrder] = react_1.useState(0);
    const [message, setMessage] = react_1.useState('');
    react_1.useEffect(() => {
        if (data !== undefined) {
            const retrievedItems = data
                .getInventoryAdjustmentInfo
                .items
                .map((item) => {
                const stockId = item.product == null ? undefined : item.product.stockId;
                return Object.assign(Object.assign({}, item), { product: { value: item.product._id, label: item.product.key, stockId }, absoluteAmount: Math.abs(item.amount), amountNegative: Math.sign(item.amount) < 0 });
            });
            setItems(retrievedItems);
        }
    }, [data]);
    if (loading)
        return react_1.default.createElement(react_1.default.Fragment, null);
    const onMessageSent = (msg) => {
        setMessage(msg);
    };
    const onDeleteButtonClicked = () => {
        if (window.confirm('確定要刪除調整單嗎 ？')) {
            deleteInfo().then(() => {
                props.history.push('/inventoryAdjustment');
            });
        }
    };
    const isValid = (retrievedItems) => {
        for (let i = 0; i < retrievedItems.length; i += 1) {
            const item = retrievedItems[i];
            if (item.product == null)
                return false;
            if (item.absoluteAmount == null)
                return false;
            if (item.unitCost == null)
                return false;
        }
        return true;
    };
    const onSaveButtonClicked = () => __awaiter(this, void 0, void 0, function* () {
        if (!isValid(items)) {
            alert('儲存失敗，有些欄位沒有填寫');
            return;
        }
        updateInfoItems({
            variables: {
                id: inventoryAdjustmentInfoId,
                items: items.map((item) => ({
                    _id: item._id,
                    order: item.order,
                    unitCost: item.unitCost,
                    amount: (item.amountNegative ? -1 : 1) * item.absoluteAmount,
                    productId: item.product.value,
                })),
            },
        }).then(refetch);
    });
    items.sort((x, y) => x.order - y.order);
    const copy = (item) => {
        const order = maxOrder + 1;
        setItems([...items, Object.assign(Object.assign({}, item), { order })]);
        setMaxOrder(order);
    };
    const isEditable = (data.getInventoryAdjustmentInfo.status
        === InventoryAdjustmentInfoStatus_1.InventoryAdjustmentInfoStatus.Created);
    const actions = isEditable ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, { onClick: onSaveButtonClicked }, "\u5132\u5B58"),
        react_1.default.createElement(Button_1.default, { onClick: onDeleteButtonClicked }, "\u522A\u9664"),
        react_1.default.createElement(Button_1.default, { type: "submit" }, "\u8A8D\u5217"))) : (react_1.default.createElement(react_1.default.Fragment, null));
    const topActions = [
        {
            text: '返回',
            props: {},
            onClick: () => __awaiter(this, void 0, void 0, function* () {
                props.history.push('/inventoryAdjustment');
            }),
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ActionButtons_1.default, { actions: topActions, classes: null }),
        react_1.default.createElement("form", { onSubmit: (e) => {
                e.preventDefault();
                if (!isValid(items)) {
                    alert('送出失敗，有些欄位沒有填寫');
                    return;
                }
                if (window.confirm('確定要送出調整單嗎 ？')) {
                    applyInfo({
                        variables: {
                            id: inventoryAdjustmentInfoId,
                            items: items.map((item) => ({
                                _id: item._id,
                                order: item.order,
                                unitCost: item.unitCost,
                                amount: (item.amountNegative ? -1 : 1) * item.absoluteAmount,
                                productId: item.product.value,
                            })),
                        },
                    }).then(refetch);
                }
            } },
            react_1.default.createElement(Grid_1.default, { container: true },
                react_1.default.createElement(Grid_1.default, { item: true },
                    react_1.default.createElement(TextField_1.default, { label: "\u5EAB\u5B58\u8ABF\u6574\u55AE\u865F", defaultValue: data.getInventoryAdjustmentInfo.sn, disabled: true })),
                react_1.default.createElement(Grid_1.default, { item: true },
                    react_1.default.createElement(TextField_1.default, { label: "\u5275\u5EFA\u65E5\u671F", defaultValue: (() => {
                            const info = data.getInventoryAdjustmentInfo;
                            if (info.createdAt === null)
                                return '';
                            return moment_1.default(info.createdAt).format('YYYY/MM/DD').toString();
                        })(), disabled: true })),
                react_1.default.createElement(Grid_1.default, { item: true },
                    react_1.default.createElement(TextField_1.default, { label: "\u8A8D\u5217\u65E5\u671F", defaultValue: (() => {
                            const info = data.getInventoryAdjustmentInfo;
                            if (info.submittedAt === null)
                                return '';
                            return moment_1.default(info.submittedAt).format('YYYY/MM/DD').toString();
                        })(), disabled: true })),
                react_1.default.createElement(Grid_1.default, { item: true },
                    react_1.default.createElement(TextField_1.default, { label: "\u72C0\u614B", defaultValue: (() => {
                            const status = data.getInventoryAdjustmentInfo.status;
                            if (status === InventoryAdjustmentInfoStatus_1.InventoryAdjustmentInfoStatus.Created) {
                                return '已創建';
                            }
                            if (status === InventoryAdjustmentInfoStatus_1.InventoryAdjustmentInfoStatus.Deleted) {
                                return '已刪除';
                            }
                            if (status === InventoryAdjustmentInfoStatus_1.InventoryAdjustmentInfoStatus.Finished) {
                                return '已完成';
                            }
                            return status;
                        })(), disabled: true }))),
            react_1.default.createElement(List_1.default, null,
                react_1.default.createElement(Typography_1.default, null, "\u9805\u76EE\u6E05\u55AE"),
                items.map((item) => (react_1.default.createElement(InventoryAdjustmentListItemUIView_1.InventoryAdjustmentListItemUIView, { required: true, editable: isEditable, key: item.order, item: item, onItemPropertyChanged: (selectedItem) => {
                        setItems(items
                            .filter(e => e !== selectedItem)
                            .concat(Object.assign({}, selectedItem)));
                    }, onCopyButtonClicked: copy, onDeleteButtonClicked: () => {
                        setItems(items.filter(e => e !== item));
                    }, onMessageSent: onMessageSent }))),
                // eslint-disable-next-line consistent-return
                (() => {
                    if (isEditable) {
                        return (react_1.default.createElement(InventoryAdjustmentListItemUIView_1.InventoryAdjustmentListItemUIView, { editable: isEditable, required: false, key: maxOrder, item: { order: maxOrder }, onItemPropertyChanged: (item) => {
                                copy(Object.assign({}, item));
                            }, onCopyButtonClicked: copy }));
                    }
                })()),
            react_1.default.createElement(Grid_1.default, null,
                react_1.default.createElement(Grid_1.default, null, actions))),
        react_1.default.createElement(core_1.Snackbar, { open: message !== '', onClose: () => setMessage(''), autoHideDuration: 1000, message: react_1.default.createElement(react_1.default.Fragment, null, message) })));
}
exports.default = InventoryAdjustmentInfoUIView;
/*
<Grid container>
  <Grid item>
    <Select
      value={warehouse!}
      label={"倉儲單位"}
      options={
        async (input: string) => {
          let response = await props.client.query({
            query: GET_WAREHOUSES,
            variables: {
              partialName: input,
              limit: 50,
            }
          })
          return response.data.getWarehouses.map(
            (e: Warehouse) => ({
              value: e.id,
              label: e.name,
            }))
        }
      }
      onChange={(option) => {
        setWarehouse(option)
      }}
    />
  </Grid>
  <Grid item xs={6}>
    <TextField
      label={"填寫庫存調整理由"}
      fullWidth={true}
      onChange={(e) => {
        setReason(e.target.value)
      }}
    />
  </Grid>
</Grid>
 */
